(function(){
  var root=document.getElementById('cm-drawer'); if(!root)return;
  var d=root.dataset, body=root.querySelector('[data-body]'), foot=root.querySelector('[data-foot]'), top=root.querySelector('[data-top]');
  var cnt=root.querySelector('[data-count]'), tot=root.querySelector('[data-total]'), timerEl=root.querySelector('[data-timer]');
  var sv=root.querySelector('[data-save]'), svv=root.querySelector('[data-save-val]');
  var tpl=root.querySelector('template[data-empty]');
  var CMP={}; try{CMP=JSON.parse(root.querySelector('[data-cmp]').textContent)||{}}catch(e){}
  var ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var CUR=d.currency||'PLN';
  var TRASH='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  var TAGI='<svg width="16" height="16" viewBox="0 0 24 24" fill="#333"><path d="M2 12V3h9l11 11-9 9L2 12zm5-6a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"/></svg>';
  function fmt(c){try{return new Intl.NumberFormat('pl-PL',{style:'currency',currency:CUR}).format(c/100)}catch(e){return (c/100).toFixed(2)+' '+CUR}}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]})}
  function img(u){return u?u+(u.indexOf('?')>-1?'&':'?')+'width=200':''}
  var KEY='cmCartEnd', TOTAL=10*60*1000, tmr=null;
  function getEnd(){var e=0;try{e=parseInt(localStorage.getItem(KEY),10)||0}catch(x){}if(!e||e<Date.now()){e=Date.now()+TOTAL;try{localStorage.setItem(KEY,e)}catch(x){}}return e}
  function tick(){var end=getEnd(),s=Math.max(0,Math.round((end-Date.now())/1000));timerEl.textContent=('0'+Math.floor(s/60)).slice(-2)+':'+('0'+(s%60)).slice(-2)}
  function startTimer(){tick();if(!tmr)tmr=setInterval(tick,1000)}
  function stopTimer(){if(tmr){clearInterval(tmr);tmr=null}try{localStorage.removeItem(KEY)}catch(x){}}
  function render(c){
    cnt.textContent=c.item_count;
    document.querySelectorAll('.cart-bubble__text-count,[data-cart-count]').forEach(function(b){b.textContent=c.item_count});
    if(!c.item_count){top.hidden=true;stopTimer();body.innerHTML=tpl.innerHTML;foot.hidden=true;return}
    top.hidden=false;startTimer();
    var save=0,h='';
    c.items.forEach(function(it){
      var cmp=(CMP[it.variant_id]||0)*it.quantity;
      var was=Math.max(cmp,it.original_line_price);
      var hasWas=was>it.final_line_price;
      if(hasWas)save+=was-it.final_line_price;
      var opts=(it.options_with_values||[]).map(function(o){return esc(o.name)+': '+esc(o.value)}).join(' · ');
      h+='<div class="cmd__item" data-key="'+esc(it.key)+'">'+
        '<a class="cmd__img" href="'+esc(it.url)+'">'+(it.image?'<img src="'+esc(img(it.image))+'" alt="">':'')+'</a>'+
        '<div class="cmd__main"><button type="button" class="cmd__rm" data-rm aria-label="'+esc(d.remove)+'">'+TRASH+'</button>'+
        '<p class="cmd__nm">'+esc(it.product_title)+'</p>'+
        (opts?'<p class="cmd__var">'+opts+'</p>':'')+
        '<p class="cmd__pr">'+(hasWas?'<s>'+fmt(was)+'</s>':'')+'<b>'+fmt(it.final_line_price)+'</b>'+(hasWas?'<em>('+esc(d.saveText)+' '+fmt(was-it.final_line_price)+')</em>':'')+'</p>'+
        '<div class="cmd__qty"><button type="button" data-q="-1" aria-label="-">&minus;</button><span>'+it.quantity+'</span><button type="button" data-q="1" aria-label="+">+</button></div>'+
        '<div class="cmd__tag">'+TAGI+'<span>'+esc(d.tag)+'</span></div></div></div>';
    });
    body.innerHTML=h;
    tot.textContent=fmt(c.total_price);
    sv.hidden=!(save>0); svv.textContent=fmt(save);
    foot.hidden=false;
  }
  function get(){return fetch(ROOT+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json()})}
  function change(key,q){return fetch(ROOT+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(function(r){return r.json()})}
  function refresh(){return get().then(render)}
  function open(){root.classList.add('is-open');root.setAttribute('aria-hidden','false');document.body.classList.add('cmd-lock')}
  function close(){root.classList.remove('is-open');root.setAttribute('aria-hidden','true');document.body.classList.remove('cmd-lock')}
  body.addEventListener('click',function(e){
    var row=e.target.closest('.cmd__item'); if(!row)return;
    var q=e.target.closest('[data-q]'), rm=e.target.closest('[data-rm]'); if(!q&&!rm)return;
    var now=parseInt(row.querySelector('.cmd__qty span').textContent,10)||1;
    var next=rm?0:Math.max(0,now+parseInt(q.dataset.q,10));
    row.style.opacity='.5';
    change(row.dataset.key,next).then(render).catch(function(){row.style.opacity=''});
  });
  root.addEventListener('click',function(e){if(e.target.closest('[data-close]'))close()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
  document.addEventListener('click',function(e){
    var t=e.target.closest&&e.target.closest('cart-icon,a[href$="/cart"],[data-cm-open-cart]');
    if(!t||root.contains(t)||e.metaKey||e.ctrlKey)return;
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    open();refresh();
  },true);
  window.cmCart={open:function(r){open();if(r!==false)refresh()},close:close,refresh:refresh};
  refresh();
})();